export default __webpack_public_path__ + "static/media/TemplateGraphic.9e99c7e4.svg";